import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import ArticleCard from '@/components/feature/ArticleCard';
import type { Article } from '@/mocks/articles';

interface LatestGridProps {
  latest: Article[];
}

export default function LatestGrid({ latest }: LatestGridProps) {
  return (
    <section id="latest" className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <SectionTitle
          eyebrow="最新线报"
          title="刚刚整理完成的深挖稿"
          desc="每篇都附带图解或信息图，关键数字均已交叉核对后才会上线。"
        />
        <Link
          to="/feed"
          className="shrink-0 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          浏览线报库
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {latest.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}